import { post } from './client'

export { fnSubmitLead }

/**
 * @typedef {object} LeadData
 * @property {string} email
 * @property {string} first_name
 * @property {string} [phone]
 * @property {string} [promo_code]
 */

/**
 * @typedef {object} HubSpot
 * @property {object} [context]
 * @property {string} form_id
 * @property {string} portal_id
 * @property {object} [legalConsentOptions]
 */

/**
 * @typedef {object} SMS
 * @property {string} content
 * @property {string} recipient
 * @property {string} sender
 */

/**
 * @typedef {object} LeadBody
 * @property {LeadData} [data]
 * @property {HubSpot} [hubspot]
 * @property {SMS} [sms]
 */

/**
 * @typedef {object} LeadResponse
 * @property {boolean} ok
 */

/**
 * @param  {LeadBody} body
 * @return {Promise<LeadResponse>}
 */
async function fnSubmitLead(body) {
  return post({
    method: 'SubmitLead',
    args: [body]
  })
}
